import { apiFetch } from './client';
import type { DashboardResponse } from '$lib/types';

export const dashboardApi = {
  get: () => apiFetch<DashboardResponse>('/dashboard')
};
